import type { Ref, HTMLAttributes } from 'react';
import { forwardRef, memo } from 'react';
import styled from '@emotion/styled';
import { cx } from '@trinity/chat-components';
import { shouldForwardProp } from '@trinity/chat-components/utils/emotion.js';
import styles from './style/ProgressBar.module.css';

type Props = {
  className?: string;
  pct: number;
} & HTMLAttributes<HTMLDivElement>;

export const ProgressBar = memo(forwardRef(({
  className,
  pct,
  ...rest
}: Props, ref: Ref<HTMLDivElement>) => {
  const fillWidth = Math.min(pct, 100);

  return (
    <div
      {...rest}
      className={cx(styles.root, className)}
      ref={ref}>
      <Bar
        width={`${fillWidth}%`} />
    </div>
  );
}));

export default ProgressBar;

const Bar = styled('div', { shouldForwardProp: shouldForwardProp('width') })<{ width: string }>(({ theme, width }) => ({
  position: 'absolute',
  backgroundColor: theme.palette.primary.main,
  left: 0,
  height: '100%',
  borderTopRightRadius: '2px',
  borderBottomRightRadius: '2px',
  width,
}));